import { FormControl, MenuItem, Select, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useDevices from "./useDevices";

export default function AudioInputList({ localTracks }) {
  const { t } = useTranslation();
  const { audioInputDevices } = useDevices();

  const localAudioTrack = localTracks.find((track) => track.kind === "audio");
  const [storedLocalAudioDeviceId, setStoredLocalAudioDeviceId] = useState("");
  const localAudioInputDeviceId =
    storedLocalAudioDeviceId ||
    localAudioTrack?.mediaStreamTrack?.getSettings().deviceId ||
    "";

  function replaceTrack(newDeviceId) {
    setStoredLocalAudioDeviceId(newDeviceId);
    if (localAudioTrack) {
      localAudioTrack.restart({
        width: 1280,
        height: 720,
        frameRate: 24,
        deviceId: { exact: newDeviceId },
      });
    }
  }

  return (
    <FormControl fullWidth>
      <Typography variant="subtitle2" gutterBottom>
        {t("frontend.audio_input")}
      </Typography>
      <Select
        onChange={(e) => replaceTrack(e.target.value)}
        value={localAudioInputDeviceId}
        variant="outlined"
      >
        {audioInputDevices.map((device) => (
          <MenuItem value={device.deviceId} key={device.deviceId}>
            {device.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
